import { IAdminText } from '../../components/admin/supervisors/interfaces';

export enum AdminTextActionType {
    CREATE_ADMIN_TEXT = 'CREATE_ADMIN_TEXT',
    UPDATE_ADMIN_TEXT = 'UPDATE_ADMIN_TEXT',
    GET_ALL_ADMIN_TEXTS = 'GET_ALL_ADMIN_TEXTS',
    GET_ADMIN_TEXTS_BY_ROLE = 'GET_ADMIN_TEXTS_BY_ROLE',
    DELETE_ADMIN_TEXT = 'DELETE_ADMIN_TEXT',
    GET_LAYER_ADMIN_TEXTS = 'GET_LAYER_ADMIN_TEXTS',
}

interface GetAdminTextAction {
    type: AdminTextActionType.GET_ALL_ADMIN_TEXTS;
    payload: Array<IAdminText>;
}

interface GetAdminTextByRoleAction {
    type: AdminTextActionType.GET_ADMIN_TEXTS_BY_ROLE;
    payload: Array<IAdminText>;
}

interface GetLayerAdminTextAction {
    type: AdminTextActionType.GET_LAYER_ADMIN_TEXTS;
    payload: Array<IAdminText>;
}

interface CreateAdminTextAction {
    type: AdminTextActionType.CREATE_ADMIN_TEXT;
    payload: IAdminText;
}

interface UpdateAdminTextAction {
    type: AdminTextActionType.UPDATE_ADMIN_TEXT;
    payload: IAdminText;
}

interface DeleteAdminTextAction {
    type: AdminTextActionType.DELETE_ADMIN_TEXT;
    payload: IAdminText;
}

export type AdminTextAction =
    | GetAdminTextAction
    | GetAdminTextByRoleAction
    | CreateAdminTextAction
    | UpdateAdminTextAction
    | DeleteAdminTextAction
    | GetLayerAdminTextAction;
